import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { apiRequest } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem("ritzyra_token") || null);
  const [user, setUser] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("ritzyra_user") || "null");
    } catch {
      return null;
    }
  });
  const [loading, setLoading] = useState(true);

  const persist = useCallback((tok, usr) => {
    if (tok) localStorage.setItem("ritzyra_token", tok);
    else localStorage.removeItem("ritzyra_token");
    if (usr) localStorage.setItem("ritzyra_user", JSON.stringify(usr));
    else localStorage.removeItem("ritzyra_user");
    setToken(tok || null);
    setUser(usr || null);
  }, []);

  useEffect(() => {
    let active = true;
    (async () => {
      if (token) {
        try {
          const me = await apiRequest("/auth/me", { token });
          if (active) persist(token, me);
        } catch {
          if (active) persist(null, null);
        }
      }
      if (active) setLoading(false);
    })();
    return () => {
      active = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const login = async (email, password) => {
    const res = await apiRequest("/auth/login", { method: "POST", body: { email, password } });
    persist(res.access_token, res.user);
    return res.user;
  };

  const register = async (name, email, password) => {
    const res = await apiRequest("/auth/register", { method: "POST", body: { name, email, password } });
    persist(res.access_token, res.user);
    return res.user;
  };

  const logout = async () => {
    try {
      await apiRequest("/auth/logout", { method: "POST", token });
    } catch {
      /* ignore */
    }
    persist(null, null);
  };

  return (
    <AuthContext.Provider value={{ token, user, loading, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used inside AuthProvider");
  return ctx;
}
